/** Depleting ring that loops every `seconds` — the visible "live QR" cue. */
export function CountdownRing({ seconds = 30, size = 26 }: { seconds?: number; size?: number }) {
  const r = 10;
  const circ = 2 * Math.PI * r;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      aria-hidden="true"
      style={{ display: 'block' }}
    >
      <circle cx="13" cy="13" r={r} fill="none" stroke="var(--line)" strokeWidth="2.5" />
      <circle
        cx="13"
        cy="13"
        r={r}
        fill="none"
        stroke="var(--success)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeDasharray={circ}
        transform="rotate(-90 13 13)"
        style={{ animation: `wb-ring-deplete ${seconds}s linear infinite` }}
      />
      <style>{`@keyframes wb-ring-deplete { from { stroke-dashoffset: 0; } to { stroke-dashoffset: ${circ}; } }
        @media (prefers-reduced-motion: reduce){ circle[style]{ animation: none !important; } }`}</style>
    </svg>
  );
}
